import { FormControlLabel, Grid, Switch, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { checkNumber } from "../utilities/FormValidation";
import OAuthService from "src/app/auth/services/oAuthService";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const UsanseForm = forwardRef((props, ref) => {
    const [validError, setValidError] = useState();
    const [error, setError] = useState();
    const [successMsg, setSuccessMsg] = useState();
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [editData, setEditdata] = useState();
    const [usanceData, setUsanceData] = useState({
        noOfDays: 0,
        description: "",
        isActive: true
    })
    const UsanceUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.usances}`;

    const getEditUsnace = async () => {
        let id = props.select[0]._links?.self?.href.split('/').pop();
        try {
            const refData = await OAuthService.getList(UsanceUrl + `/${id}`)
            if (refData?.data) {
                setUsanceData({
                    ...usanceData,
                    noOfDays: refData.data.noOfDays,
                    description: refData.data.description,
                    isActive: refData.data.isActive
                })
                setEditdata({
                    ...usanceData,
                    noOfDays: refData.data.noOfDays,
                    description: refData.data.description,
                    isActive: refData.data.isActive
                })
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
        }

    }
    useEffect(() => {
        let id = props.select[0]?._links?.self?.href.split('/').pop();
        if (id) {
            getEditUsnace()
        }
    }, [])

    const handleNoDaysChange = (e) => {
        setUsanceData({ ...usanceData, noOfDays: e.target.value})
    }
    
    useEffect(() => {
        if (usanceData?.description && usanceData?.noOfDays && !validError) {
            if (usanceData?.description !== editData?.description || Number(usanceData?.noOfDays) !== Number(editData?.noOfDays) || usanceData?.isActive !== editData?.isActive) {
                setSaveDisabled(false);
            } 
            else{
                setSaveDisabled(true)
            }
        } else {
            setSaveDisabled(true)
        }
    }, [usanceData])

    useEffect(() => {
        props.checkSaveDisabled(saveDisabled)
    }, [saveDisabled])

    const handleSubmit = async () => {
        let model = {
            ...usanceData,
            noOfDays:Number(usanceData.noOfDays)
        }

        let id = props.select[0]?._links?.self?.href.split('/').pop();
        try {
            if (id) {
                await OAuthService.updateData(UsanceUrl, id, model);
                setSuccessMsg("Usance Updated Successfully")
                return 'Usance Updated successfully.'
            }
            else {
                await OAuthService.addData(UsanceUrl, model);
                setSuccessMsg('Usance added successfully.')
                return 'Usance added successfully.'
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
        }
    }

    const handleReportChange = (e) => {
        setUsanceData({ ...usanceData, isActive: e.target.checked });
    };


    useImperativeHandle(ref, () => ({
        handleSubmit: handleSubmit
    }))
    useEffect(() => {
        props.successMsg(successMsg)
    }, [successMsg]);
    return (
        <>
            <Grid container spacing={2} className="mt-2">
                <Grid item xs={5}>
                    <label className="min-w-fit">Number Of Days</label>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        name='noDays'
                        value={usanceData.noOfDays}
                        size="small"
                        onChange={(e) => { handleNoDaysChange(e); setValidError(checkNumber(e.target.value)) }}
                        helperText={validError}
                    />
                </Grid>

            </Grid>
            <Grid container spacing={2} className="mt-2">
                <Grid item xs={5}>
                    <label className="min-w-fit">Description</label>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        name='description'
                        value={usanceData.description}
                        size="small"
                        onChange={(e) => setUsanceData({ ...usanceData, description: e.target.value })}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} >
                <Grid item xs={12} className="mt-12">
                    <div className="flex items-baseline">
                        <label className=" float-left pr-5 pl-5 ">IsActive</label>
                        <Switch checked={usanceData.isActive} onChange={handleReportChange} />
                    </div>
                </Grid>
            </Grid>
        </>

    )
})
export default UsanseForm